import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useQuery } from "@tanstack/react-query";
import { fetchBranches } from "@/api/branches";
import { downloadFinanceXlsx } from "@/api/finance";

export function FinanceExportDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { data: branches } = useQuery({ queryKey: ["branches"], queryFn: fetchBranches });
  const [branchId, setBranchId] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  return <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>Выгрузка финансов</DialogTitle>
    <DialogContent>
      <Stack spacing={2} mt={1}>
        <TextField select label="Филиал" value={branchId} onChange={(event) => setBranchId(event.target.value)}>
          <MenuItem value="">Все доступные филиалы</MenuItem>
          {(branches ?? []).map((branch) => <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>)}
        </TextField>
        <TextField label="Дата с" type="date" value={from} onChange={(event) => setFrom(event.target.value)} InputLabelProps={{ shrink: true }} />
        <TextField label="Дата по" type="date" value={to} onChange={(event) => setTo(event.target.value)} InputLabelProps={{ shrink: true }} />
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Отмена</Button>
      <Button variant="contained" onClick={() => void downloadFinanceXlsx({ branchId: branchId || undefined, from: from || undefined, to: to || undefined })}>Скачать XLSX</Button>
    </DialogActions>
  </Dialog>;
}
